/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTeamsInviteTokenQueryResponse,
  GetTeamsInviteTokenPathParams,
  GetTeamsInviteToken404,
  GetTeamsInviteToken500,
} from "../types/GetTeamsInviteToken.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTeamsInviteTokenQueryKey = (
  token: GetTeamsInviteTokenPathParams["token"] | undefined,
) => [{ url: "/teams/invite/:token", params: { token: token } }] as const;

export type GetTeamsInviteTokenQueryKey = ReturnType<
  typeof getTeamsInviteTokenQueryKey
>;

/**
 * {@link /teams/invite/:token}
 */
export async function getTeamsInviteToken(
  token: GetTeamsInviteTokenPathParams["token"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTeamsInviteTokenQueryResponse,
    ResponseErrorConfig<GetTeamsInviteToken404 | GetTeamsInviteToken500>,
    unknown
  >({ method: "GET", url: `/teams/invite/${token}`, ...requestConfig });
  return res;
}

export function getTeamsInviteTokenQueryOptions(
  token: GetTeamsInviteTokenPathParams["token"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getTeamsInviteTokenQueryKey(token);
  return queryOptions<
    ResponseConfig<GetTeamsInviteTokenQueryResponse>,
    ResponseErrorConfig<GetTeamsInviteToken404 | GetTeamsInviteToken500>,
    ResponseConfig<GetTeamsInviteTokenQueryResponse>,
    typeof queryKey
  >({
    enabled: !!token,
    queryKey,
    queryFn: async ({ signal }) => {
      return getTeamsInviteToken(token!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * {@link /teams/invite/:token}
 */
export function useGetTeamsInviteToken<
  TData = ResponseConfig<GetTeamsInviteTokenQueryResponse>,
  TQueryData = ResponseConfig<GetTeamsInviteTokenQueryResponse>,
  TQueryKey extends QueryKey = GetTeamsInviteTokenQueryKey,
>(
  token: GetTeamsInviteTokenPathParams["token"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTeamsInviteTokenQueryResponse>,
        ResponseErrorConfig<GetTeamsInviteToken404 | GetTeamsInviteToken500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getTeamsInviteTokenQueryKey(token);

  const query = useQuery(
    {
      ...getTeamsInviteTokenQueryOptions(token, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetTeamsInviteToken404 | GetTeamsInviteToken500>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
